import CustomFieldsView from '../CustomFieldsView.vue'
import CustomFieldList  from '../Pages/CustomFieldList.vue'

// CDEF010: Mantenimiento > Campos personalizados.
const routes = [
  {
    path: '/mantenimiento/campos-personalizados',
    component: CustomFieldsView,
    children: [
      { path: '', name: 'custom-field-list', component: CustomFieldList },
    ],
  },
]

export default routes
